var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ActionsColumn } from "@/components/ActionButons";
import { ListActions } from "@/components/ListActions";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, styled, Typography } from "@mui/material";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment-timezone";
import { DatagridConfigurable, FunctionField, List, SelectInput, TextField, TextInput, useGetList, useGetOne, useListContext, useNotify, useRefresh, WrapperField, } from "react-admin";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "@/providers/TenantContextProvider";
import CreateEvent, { EventProcessors } from "./CreateScheduledEvent";
import { Dialog } from "@sequentech/ui-essentials";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { IPermissions } from "@/types/keycloak";
import { useMutation } from "@apollo/client";
import { MANAGE_ELECTION_DATES } from "@/queries/ManageElectionDates";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import ElectionHeader from "@/components/ElectionHeader";
import { useScheduledEventPermissions } from "../ElectionEvent/useScheduledEventPermissions";
export var DataGridContainerStyle = styled(DatagridConfigurable)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", "px) {\n        width: 100%;\n        ", "\n        &  > div:first-child {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"], ["\n    @media (min-width: ", "px) {\n        width: 100%;\n        ", "\n        &  > div:first-child {\n            position: absolute;\n            width: 100%;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.md;
}, function (_a) {
    var isOpenSideBar = _a.isOpenSideBar;
    return "max-width: ".concat(isOpenSideBar ? "calc(100vw - 355px)" : "calc(100vw - 108px)", ";");
});
var FilterWatcher = function (_a) {
    var fieldName = _a.fieldName, onFilterChange = _a.onFilterChange;
    var filterValues = useListContext().filterValues;
    var previousFilters = useRef(filterValues);
    useEffect(function () {
        // Check which filters were removed
        Object.keys(previousFilters.current).forEach(function (key) {
            if (!(key in filterValues)) {
                if (key === fieldName) {
                    onFilterChange();
                }
            }
        });
        previousFilters.current = filterValues;
    }, [filterValues]);
    return null;
};
var ListScheduledEvents = function (_a) {
    var electionEventId = _a.electionEventId;
    var t = useTranslation().t;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var tenantId = useTenantStore()[0];
    var refresh = useRefresh();
    var notify = useNotify();
    var _b = useState(false), isDeleteModalOpen = _b[0], setIsDeleteModalOpen = _b[1];
    var _c = useState(), isDeleteId = _c[0], setIsDeleteId = _c[1];
    var _d = useState(false), isEditEvent = _d[0], setIsEditEvent = _d[1];
    var _e = useState(false), openCreateEvent = _e[0], setOpenCreateEvent = _e[1];
    var _f = useState(), selectedEventId = _f[0], setSelectedEventId = _f[1];
    var aliasRenderer = useAliasRenderer();
    var _g = useScheduledEventPermissions(), canWriteScheduledEvent = _g.canWriteScheduledEvent, canCreateScheduledEvent = _g.canCreateScheduledEvent, canDeleteScheduledEvent = _g.canDeleteScheduledEvent, showScheduledEventColumns = _g.showScheduledEventColumns;
    var manageElectionDates = useMutation(MANAGE_ELECTION_DATES, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.SCHEDULED_EVENT_WRITE,
            },
        },
    })[0];
    var scheduledEventToDelete = useGetOne("sequent_backend_scheduled_event", {
        id: isDeleteId !== null && isDeleteId !== void 0 ? isDeleteId : tenantId,
        meta: { tenant_id: tenantId },
    }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    }).data;
    var elections = useGetList("sequent_backend_election", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "created_at", order: "DESC" },
        filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
            archived_at: {
                format: "hasura-raw-query",
                value: { _is_null: true },
            },
        },
    }, {
        refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    }).data;
    var _h = useState(null), eventScreeElectionId = _h[0], setEventScreenElectionId = _h[1];
    var electionIds = useMemo(function () {
        var _a;
        var electionsList = (_a = elections === null || elections === void 0 ? void 0 : elections.map(function (election) { return election.id; })) !== null && _a !== void 0 ? _a : [];
        if (eventScreeElectionId) {
            electionsList = electionsList.filter(function (item) { return item === eventScreeElectionId; });
        }
        return electionsList;
    }, [elections, eventScreeElectionId]);
    var getElectionName = function (scheduledEvent) {
        var _a;
        var electionId = (_a = scheduledEvent === null || scheduledEvent === void 0 ? void 0 : scheduledEvent.event_payload) === null || _a === void 0 ? void 0 : _a.election_id;
        var foundElection = elections === null || elections === void 0 ? void 0 : elections.find(function (item) { return electionId === item.id; });
        return (foundElection && aliasRenderer(foundElection)) || "-";
    };
    var OMIT_FIELDS = ["id"];
    var editAction = function (id) {
        setOpenCreateEvent(true);
        setIsEditEvent(true);
        setSelectedEventId(id);
    };
    var handleClose = function () {
        setOpenCreateEvent(false);
        setIsEditEvent(false);
    };
    var confirmDeleteAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, variables, errors, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!scheduledEventToDelete) return [3 /*break*/, 4];
                    payload = scheduledEventToDelete.event_payload;
                    if (!(scheduledEventToDelete.election_event_id &&
                        scheduledEventToDelete.event_processor)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    variables = {
                        electionEventId: scheduledEventToDelete.election_event_id,
                        electionId: payload === null || payload === void 0 ? void 0 : payload.election_id,
                        scheduledDate: undefined,
                        eventProcessor: scheduledEventToDelete.event_processor,
                    };
                    return [4 /*yield*/, manageElectionDates({
                            variables: variables,
                        })];
                case 2:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        console.error(errors);
                        notify(t("eventsScreen.messages.editError"), { type: "error" });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    notify(t("eventsScreen.messages.editError"), { type: "error" });
                    return [3 /*break*/, 4];
                case 4:
                    refresh();
                    setIsDeleteModalOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteAction = function (id) {
        setIsDeleteId(id);
        setIsDeleteModalOpen(true);
        setOpenCreateEvent(false);
    };
    var actions = [
        {
            icon: _jsx(EditIcon, { className: "edit-voter-icon" }),
            action: function (id) { return editAction(id); },
            showAction: function () { return canWriteScheduledEvent; },
        },
        {
            icon: _jsx(DeleteIcon, { className: "delete-voter-icon" }),
            action: function (id) { return deleteAction(id); },
            showAction: function () { return canDeleteScheduledEvent; },
            label: t("common.label.delete"),
            className: "delete-voter-icon",
        },
    ];
    var onOpenDrawer = function () {
        setOpenCreateEvent(!openCreateEvent);
    };
    var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("eventsScreen.empty.header") })), canCreateScheduledEvent ? (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body1", paragraph: true }, { children: t("eventsScreen.empty.body") })), _jsx(ResourceListStyles.EmptyButtonList, __assign({ className: "voter-add-button" }, { children: _jsxs(Button, __assign({ onClick: function () { return setOpenCreateEvent(true); } }, { children: [_jsx(ResourceListStyles.CreateIcon, { icon: faPlus }), t("eventsScreen.empty.button")] })) }))] })) : null] })); };
    // Define the filters as an array of elements
    var Filters = [
        _jsx(SelectInput, { source: "event_processor", label: t("eventsScreen.fields.eventProcessor"), choices: Object.values(EventProcessors).map(function (eventType) { return ({
                id: eventType,
                name: t("eventsScreen.eventType.".concat(eventType)),
            }); }) }, "event_processor_filter"),
        _jsx(SelectInput, { source: "event_payload.election_id", label: t("eventsScreen.fields.electionId"), choices: elections === null || elections === void 0 ? void 0 : elections.map(function (election) { return ({
                id: election.id,
                name: aliasRenderer(election),
            }); }), onChange: function (e) {
                setEventScreenElectionId(e.target.value);
            } }, "election_id_filter"),
        _jsx(TextInput, { source: "id", label: "id" }, "id_filter"),
    ];
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: t("eventsScreen.title"), subtitle: "eventsScreen.subtitle" }), _jsx(List, __assign({ resource: "sequent_backend_scheduled_event", filter: {
                    election_event_id: electionEventId || undefined,
                    tenant_id: tenantId,
                    archived_at: {
                        format: "hasura-raw-query",
                        value: { _is_null: true },
                    },
                    event_payload: {
                        format: "hasura-raw-query",
                        value: {
                            _contains: { election_id: electionIds },
                        },
                    },
                }, filters: Filters, queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: _jsx(Empty, {}), actions: _jsx(ListActions, { withColumns: showScheduledEventColumns, withImport: false, withExport: false, open: openCreateEvent, setOpen: onOpenDrawer, Component: _jsx(CreateEvent, { electionEventId: electionEventId, setIsOpenDrawer: setOpenCreateEvent, getElectionName: getElectionName }), withComponent: canCreateScheduledEvent }), disableSyncWithLocation: true }, { children: _jsxs(DatagridConfigurable, __assign({ bulkActionButtons: false, omit: OMIT_FIELDS }, { children: [_jsx(FilterWatcher, { fieldName: "event_payload", onFilterChange: function () { return setEventScreenElectionId(null); } }), _jsx(TextField, { source: "id" }), _jsx(FunctionField, { label: t("eventsScreen.fields.electionId"), source: "event_payload.election_id", render: getElectionName }), _jsx(FunctionField, { label: t("eventsScreen.fields.eventProcessor"), source: "event_processor", render: function (record) {
                                return t("eventsScreen.eventType." + record.event_processor);
                            } }), _jsx(FunctionField, { label: t("eventsScreen.fields.stoppedAt"), source: "stopped_at", render: function (record) {
                                return (record.stopped_at &&
                                    moment
                                        .tz(new Date(record.stopped_at), userTimeZone)
                                        .toLocaleString()) ||
                                    "-";
                            } }), _jsx(FunctionField, { label: t("eventsScreen.fields.scheduledDate"), source: "cron_config.scheduled_date", render: function (record) {
                                var _a;
                                return (((_a = record.cron_config) === null || _a === void 0 ? void 0 : _a.scheduled_date) &&
                                    moment
                                        .tz(new Date(record.cron_config.scheduled_date), userTimeZone)
                                        .toLocaleString()) ||
                                    "-";
                            } }), _jsx(WrapperField, __assign({ label: t("common.label.actions") }, { children: _jsx(ActionsColumn, { actions: actions }) }))] })) })), _jsx(ResourceListStyles.Drawer, __assign({ anchor: "right", open: openCreateEvent, onClose: handleClose }, { children: _jsx(CreateEvent, { electionEventId: electionEventId, setIsOpenDrawer: setOpenCreateEvent, isEditEvent: isEditEvent, selectedEventId: selectedEventId, getElectionName: getElectionName }) })), _jsx(Dialog, __assign({ variant: "warning", open: isDeleteModalOpen, ok: t("common.label.delete"), cancel: t("common.label.cancel"), title: t("common.label.warning"), handleClose: function (result) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 2];
                                return [4 /*yield*/, confirmDeleteAction()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                setIsDeleteModalOpen(false);
                                return [2 /*return*/];
                        }
                    });
                }); } }, { children: t("eventsScreen.edit.delete") }))] }));
};
export default ListScheduledEvents;
var templateObject_1;
